import { render } from "./FDE.vue?vue&type=template&id=08e0260b&scoped=true"
import script from "./FDE.vue?vue&type=script&lang=js"
export * from "./FDE.vue?vue&type=script&lang=js"

import "./FDE.vue?vue&type=style&index=0&id=08e0260b&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e0260b"]])

export default __exports__